export const ID_TYPES = [
  {
    value: 1,
    text: "Cédula Fisica",
  },
  {
    value: 2,
    text: "DIMEX",
  },
  {
    value: 3,
    text: "Pasaporte",
  },
];
